// extracted by mini-css-extract-plugin
export var actions = "_9p-8";
export var arrow = "_9p-5";
export var card = "_9p-0";
export var cardWrapper = "_9p-9";
export var fieldName = "_9p-3";
export var newValue = "_9p-6";
export var oldValue = "_9p-4";
export var orangeGlowFade = "_9p-c";
export var productSection = "_9p-1";
export var scrollToBottom = "_9p-b";
export var scrollToBottomAnchor = "_9p-a";
export var scrollToBottomIcon = "_9p-d";
export var showAllButton = "_9p-7";
export var table = "_9p-2";